

















import {Component, Vue, Watch} from 'vue-property-decorator';
import MainPanel from "@/components/MainPanel.vue";
import LoginPanel from "@/components/LoginPanel.vue";
import NoOrganisationPanel from "@/components/NoOrganisationPanel.vue";
import {AxiosStatic} from "axios";

@Component({
	components: {
		MainPanel,
		LoginPanel,
		NoOrganisationPanel
	},
})
export default class App extends Vue {
	public $http!: AxiosStatic;
	public loading: boolean = true;

	constructor() {
		super();
		this.loadUser();
	}

	get loggedin() {
		return this.$store.state.loggedin;
	}

	get hasOrganisation() {
		return !this.$store.state.noorg;
	}

	public loadUser() {
		if (('email' in this.$route.query) && ('password' in this.$route.query)) {
			let url = '/public/authenticate';
			this.$http.post(url, {'email': this.$route.query.email, 'password': this.$route.query.password}).then((response) => {
				this.$store.commit('SET_LOGGEDIN', true);
				this.$store.dispatch('loadOrganisation', {root: true});

				// load user
				this.$http.get('/private/currentuser').then((response) => {
					this.$store.commit('SET_USER', response.data);
					this.loading = false;
				})
			}).catch((error) => {
				this.loading = false;
			})
		} else {
			this.$http.get('/private/currentuser').then((response) => {
				this.$store.commit('SET_LOGGEDIN', true);
				this.$store.commit('SET_USER', response.data);
				this.$store.dispatch('loadOrganisation', {root: true}).then(() => {
					this.loading = false;
				});
			}).catch((error) => {
				this.loading = false;
			})
		}
	}

	@Watch('loggedin', { immediate: true })
	@Watch('hasOrganisation', { immediate: true })
	public watchLoggedIn() {
		if (this.loggedin && this.hasOrganisation) {
			const el = document.body;
			el.classList.remove('bg-gradient-school');
		} else {
			const el = document.body;
			el.classList.add('bg-gradient-school');
		}
	}
}
